import { render, staticRenderFns } from "./compForm.vue?vue&type=template&id=85464dee&scoped=true&"
import script from "./compForm.vue?vue&type=script&lang=js&"
export * from "./compForm.vue?vue&type=script&lang=js&"
import style0 from "./compForm.vue?vue&type=style&index=0&id=85464dee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85464dee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85464dee')) {
      api.createRecord('85464dee', component.options)
    } else {
      api.reload('85464dee', component.options)
    }
    module.hot.accept("./compForm.vue?vue&type=template&id=85464dee&scoped=true&", function () {
      api.rerender('85464dee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/nine/components/compForm.vue"
export default component.exports